<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{ data.titolo }}</span>
            <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="content m-0 p-24" style="overflow: hidden" fxLayout="column">
        <div class="mat-title mb-0" [innerHtml]="data.erroreHtml" *ngIf="data.erroreHtml && data.messaggi.length === 0; else arrayErrors"></div>
        <ng-template #arrayErrors>
            <div class="mat-title mb-0" style="overflow: auto">
                <ng-container *ngFor="let messaggio of data.messaggi">
                    <div>{{ messaggio + '\n' }}</div>
                </ng-container>
            </div>
        </ng-template>
    </mat-dialog-content>
</div>
